import { Component } from "react";
import { setTelephoneNumbers } from "../../actions/policy/policyActions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const mapStateToProps = (state) => {
  return {
    selectedPolicy: state.policyReducer && state.policyReducer.selectedPolicy
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setTelephoneNumbers: (selectedPolicy, history) =>
      dispatch(setTelephoneNumbers(selectedPolicy, history))
  };
};

class TelephoneNumberRequired extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: this.props.isTelephoneNumberRequired };
  }

  componentDidMount() {
    if (this.props.isTelephoneNumberRequired && this.props.selectedPolicy) {
      this.props
        .setTelephoneNumbers(this.props.selectedPolicy, this.props.history)
        .then(() =>
          this.setState({
            isLoading: false
          })
        );
    }
  }

  render() {
    if (this.props.children && !this.state.isLoading) {
      return this.props.children;
    }
    return null;
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TelephoneNumberRequired)
);
